const getAddressComponent = (components, type, mode = "long_name") =>
  components?.find(component => component.types.includes(type))?.[mode] || ""

export const casablancaBounds = {
  north: 33.72,
  south: 33.45,
  east: -7.42,
  west: -7.82,
}

export const normalizeLocationName = value =>
  value
    ?.normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase() || ""

export const isPlaceInCasablanca = place => {
  const componentNames = (place.address_components || []).flatMap(component => [
    component.long_name,
    component.short_name,
  ])
  const addressMentionsCasablanca = [...componentNames, place.formatted_address]
    .some(value => normalizeLocationName(value).includes("casablanca"))
  const latitude = place.geometry?.location?.lat?.()
  const longitude = place.geometry?.location?.lng?.()
  const isInsideCasablancaBounds =
    typeof latitude === "number" &&
    typeof longitude === "number" &&
    latitude >= casablancaBounds.south &&
    latitude <= casablancaBounds.north &&
    longitude >= casablancaBounds.west &&
    longitude <= casablancaBounds.east

  return addressMentionsCasablanca || isInsideCasablancaBounds
}

export const getEmptyStoreValues = (useDefaultLocation = false) => ({
  name: "",
  address: "",
  zipCode: "",
  city: "",
  country: "",
  website: "",
  location: {
    latitude: useDefaultLocation ? 33.5731 : "",
    longitude: useDefaultLocation ? -7.5898 : "",
  },
  profilePhoto: "",
  profilePhotoFile: null,
  activityId: "",
  acceptCash: true,
})

export const mapGooglePlaceToStore = place => {
  const components = place.address_components || []
  const locality =
    getAddressComponent(components, "locality") ||
    getAddressComponent(components, "administrative_area_level_2") ||
    getAddressComponent(components, "administrative_area_level_1")
  const latitude = place.geometry?.location?.lat?.()
  const longitude = place.geometry?.location?.lng?.()

  return {
    ...getEmptyStoreValues(),
    name: place.name || "",
    address: place.formatted_address || "",
    zipCode: getAddressComponent(components, "postal_code"),
    city: isPlaceInCasablanca(place) ? "Casablanca" : locality,
    country: getAddressComponent(components, "country"),
    website: place.website || "",
    location: {
      latitude: typeof latitude === "number" ? latitude : "",
      longitude: typeof longitude === "number" ? longitude : "",
    },
  }
}

export const readFileAsDataUrl = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(file)
  })

export const getStoreId = store =>
  store?.id || store?.["@id"]?.split("/").filter(Boolean).pop() || ""
